<template>
    <div  style="margin-bottom: 5em;" class="container-fluid  pt-2">
        <div class="pt-5">

            <div class="text-left py-1">
                <h4 class="text-weight-900">Buy Now Pay Later</h4>
                <p>
                    <small>Customers who took items on credit</small>
                </p>

                <p>
                    <small>Only Applies if you have enabled BNPL as one of the <a href="/settings/payments">payment
                            methods in settings</a></small>

                </p>
            </div>
       
            <div class="my-2">
                <a href="/bnpl" v-if="customerView == 1" class="btn btn-outline-secondary float-right mb-3">View As Transactions</a>
                <a href="/bnpl?customer-view=1" v-else class="btn btn-outline-primary float-right mb-3">View Per Customer</a>
            </div>
           
            <div class="my-3">
                <input v-model="bnplTable.searchTerm" type="text" class="form-control"
                    placeholder="Search by name, email, or phone number">
               

            </div>
            
        <div v-if="customerView == 1">
            
            <b-table  hover sticky-header="90vh" :items="filteredBNPLCustomer" :fields="bnplTableCustomerView.fields" sort-icon-left
                        responsive="sm" @row-clicked="rowCustomerSelected">
                        <template #cell(#)="data">
                            <span>
                                {{ data.index + 1 }}
                            </span> 
                        </template>
                        <template #cell(name)="data">

                            <p class="text-dark">{{ data.item.name }}</p>
                        </template>




                    </b-table>
            </div>
        <div v-else>
            <b-table  hover sticky-header="90vh" :items="filteredBNPLOrders" :fields="bnplTable.fields" sort-icon-left
                        responsive="sm" @row-clicked="rowSelected">
                        <template #cell(#)="data">
                            <span>
                                {{ data.index + 1 }}
                            </span> | 
                            <span v-if="data.item.order.status === 1" class="badge badge-success">
                                    Completed
                                </span>
                                <span v-else class="badge badge-danger">
                                    Pending
                                </span>
                        </template>

                        <template #cell(name)="data">

                            <p class="text-dark">{{ data.item.name }}</p>
                        </template>




                    </b-table>
        </div>

   

     




        </div>
        <b-modal ref="receiveBulkAmountModal" hide-footer>
            <div class="container">
                <form @submit.prevent="submitBulkAmount">
                    <div class="form-group">
                        <select class="custom-select" v-model="settleDebt.splitPaymentSelect">
                 <option value="null">--Select Payment--</option>
                 <option v-if="payment.enabled" v-for="payment in settleDebt.paymentGateways" :value="payment">{{ payment.payment_method }}</option>
                </select>
                <p class="text-danger" v-if="settleDebt.splitPaymentSelectErr"><small>{{ settleDebt.splitPaymentSelectErr }}</small></p>
            </div>
                    <div class="form-group">
                        <input class="form-control" type="text" v-model="settleDebt.bulkAmount"/>
                        <p class="text-danger" v-if="settleDebt.bulkAmountExceedErr"><small>{{ settleDebt.bulkAmountExceedErr }}</small></p>
                    </div>
                    <div class="form-group">
                        <button class="btn btn-primary" type="submit">Process payments</button>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal size="lg" ref="bnplCustomerTransactions" hide-footer>
            <div v-if="bnplTableCustomerView.viewPaymentTransaction">
                <div class="container text-center">
                <h3 class="text-capitalize">{{ bnplTableCustomerView.customerTrxTable.selectedCustomer.name }}</h3>
                
                <a href="#" @click="viewPaymentModal" class="text-sm">View BNPL Orders</a>
                <hr/>
                 <b-table  hover sticky-header="90vh" :items="bnplTableCustomerView.paymentTransactionsTable.items" :fields="bnplTableCustomerView.paymentTransactionsTable.fields" sort-icon-left
                        responsive="sm">
                    <template #cell(totalPaidAmount)="data">
                        <p v-if="data.item.totalPaidAmount > 0">{{ convertCurrencyToShillings(data.item.totalPaidAmount) }}</p>
                    </template>
                    <template #cell(time)="data">
                       <p>{{ formatDate(data.item.time, 'hh:mm A DD-MMM-Y') }}</p>
                    </template>
                    <template #cell(action)="data">
                        
                       <a @click="reverseBulkTransaction(data.item,bnplTableCustomerView.customerTrxTable.selectedCustomer)" class="btn btn-sm btn-danger">Reverse</a>
                        <small>Only do this if you are sure!</small>
                    </template>
                    </b-table> 
                </div>
                   
                        
                       
        </div>    
        <div v-else>
            <div class="container text-center">
                <h3 class="text-capitalize">{{ bnplTableCustomerView.customerTrxTable.selectedCustomer.name }}</h3>
                
                <a href="#" @click="viewPaymentModal" class="text-sm">View all Payment Transactions</a>
                <hr/>
                
                <div v-if="bnplTableCustomerView.customerTrxTable.selectedCustomer.clientBalance > 0" >
                    <p class="text-capitalize badge badge-secondary">Total: {{ bnplTableCustomerView.customerTrxTable.selectedCustomer.totalAmount }}</p>
                    <p class="text-capitalize badge badge-success">Paid: {{ bnplTableCustomerView.customerTrxTable.selectedCustomer.paidAmount }}</p>
                    <p class="text-capitalize badge badge-danger">Balance: {{ bnplTableCustomerView.customerTrxTable.selectedCustomer.totalAmountBalance }}</p>
                <hr />
                    <p><small>Instead of clearing one order you can receive bulk amount from client to offset several orders</small></p>
                    <p class="text-center"><a @click="receiveBulkAmountModalOpen" class="btn btn-primary btn-sm">Receive Bulk Amount</a></p>
                    <hr />
                </div>
                <div v-else>
                    <p class="text-capitalize badge badge-secondary">Cleared {{ bnplTableCustomerView.customerTrxTable.selectedCustomer.clientBalance }}</p>
                </div>
               
               
          
            </div>
         
            <b-table  hover sticky-header="90vh" :items="bnplTableCustomerView.customerTrxTable.items" :fields="bnplTableCustomerView.customerTrxTable.fields" sort-icon-left
                        responsive="sm" @row-clicked="rowSelectedTransaction">
                        <template #cell(#)="data">
                            <span>
                                {{ data.index + 1 }}
                            </span> | 
                            <span v-if="data.item.order.status === 1" class="badge badge-success">
                                    Completed
                                </span>
                                <span v-else class="badge badge-danger">
                                    Pending
                                </span>
                        </template>
            </b-table>
        </div>  
            
        </b-modal>
        <b-modal ref="bnplDetailsModal" hide-footer>
            <div class="container-fluid">
                <div class="text-center">
                    
                    <h2>BNPL Details</h2>
                    <span v-if="selectedBNPLCustomer.order.status === 1" class="badge badge-success">
                            Completed
                        </span>
                        <span v-else class="badge badge-danger">
                            Pending
                        </span>
                    <hr />
                    <h5 class="py-1"><i class="bi bi-person"></i> {{ selectedBNPLCustomer.name }}</h5>

                    <p class="py-1"><i class="bi bi-phone"></i> {{ selectedBNPLCustomer.phone }}</p>
                    <p class="py-1"><i class="bi bi-envelope"></i> {{ selectedBNPLCustomer.email }}</p>

                    <div class="d-inline pt-2">
                        <small class="text-primary">Rating : 4.8 / 5</small>
                    </div>
                    <hr />
                </div>
                <table class="table table-striped">

                    <tbody>
                        <tr>
                            <td>Amount</td>
                            <td>{{ convertCurrencyToShillings(selectedBNPLCustomer.order.total_amount) }}</td>
                        </tr>
                        <tr>
                            <td>Order</td>
                            <td><a :href="'/orders?order-number=' + selectedBNPLCustomer.orderId + '&source=/bnpl'">{{ selectedBNPLCustomer.orderNumber }}
                                    | View </a></td>
                        </tr>
                        <tr>
                            <td>Due Date</td>
                            <td>{{ selectedBNPLCustomer.due_date }}</td>
                        </tr>

                        <tr>
                            <td>Deposit</td>
                            <td>{{ convertCurrencyToShillings(selectedBNPLCustomer.deposit) }}</td>
                        </tr>
                        <tr>
                            <td>Balance</td>
                            <td>{{ convertCurrencyToShillings(selectedBNPLCustomer.order.balance) }}</td>
                        </tr>


                    </tbody>
                </table>

                <div class="btn-group">
                    <button v-if="userDetails.roles[0].name === 'Admin' || hasPermission('can manage orders')"  @click="deleteBNPL(selectedBNPLCustomer.id)"
                        class="btn btn-sm btn-danger mx-1 rounded">Delete</button>
                    <a v-if="selectedBNPLCustomer.order.status !==1"
                        :href="'/checkout/' + selectedBNPLCustomer.orderId"
                        class="btn btn-sm btn-success mx-1 rounded">Complete</a>
                    <button @click="sendReminder(selectedBNPLCustomer.id)"
                        class="btn btn-sm btn-secondary mx-1 rounded">Send Reminder</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
    export default {
        name: 'bnpl',
        props: ['customerView'],
        data() {
            return {
                bnplTableCustomerView: {
                    fields: [
                        "#",
                        {
                            key: "name",
                            sortable: true
                        },
                        
                        {
                            key: "phone",
                            sortable: false
                        },
                        {
                            key: "balance",
                            sortable: false
                        }
                    ],
                    items: [],
                    searchTerm:'',
                    filteredCustomers:'',
                    searchTable:false,
                    customerTransactions:{},
                    customerTrxTable:{
                        fields: [
                        "#",
                        {
                            key: "order_number",
                            sortable: true
                        },
                        
                        {
                            key: "amount",
                            sortable: true
                        },
                        {
                            key: "deposit",
                            sortable: true
                        },
                        {
                            key: "due_date",
                            sortable: true
                        },
                        
                    ],
                    items: [],
                    selectedCustomer:{}
                    },
                    viewPaymentTransaction:false,
                    paymentTransactionsTable:{
                        fields:[
                            {key:'totalPaidAmount',label:'Amount Received'},
                            {key:'time',label:'Date'},
                            // {key:'orders',label:'Orders Paid'},
                            {key:'action',label:'Action'},
                            
                            
                        ],
                        items:[]
                    }
                },
                
                settleDebt:{
                    bulkAmount:'',
                    bulkAmountExceedErr:'',
                    customerDetails:'',
                    splitPaymentSelect:null,
                    splitPaymentSelectErr:'',
                    paymentGateways:{},
                },
                bnplTable: {
                    fields: [
                        "#",
                        {
                            key: "name",
                            sortable: true
                        },
                        
                        {
                            key: "phone",
                            sortable: false
                        },
                        
                        {
                            key: "amount",
                            sortable: true
                        },
                        {
                            key: "deposit",
                            sortable: true
                        },
                        {
                            key: "due_date",
                            sortable: true
                        },
                    ],
                    items: [],
                    searchTerm:'',
                    filteredCustomers:'',
                    searchTable:false
                },
                hasPermission(permissionName) {
               
               return this.userDetails.permissions.some(permission => permission.name === permissionName);
            },
                selectedBNPLCustomer:{
                    order:{},
                    finalorder:{}
                },
            

                
                
            }
        },
        computed: {
         
         ...mapGetters(['userDetails']),
        
         filteredBNPLOrders() {
                 return this.bnplTable.items.filter(customer =>
                (customer.name && customer.name.toLowerCase().includes(this.bnplTable.searchTerm)) ||
                (customer.email && customer.email.toLowerCase().includes(this.bnplTable.searchTerm)) ||
                (customer.phone && customer.phone.includes(this.bnplTable.searchTerm)) ||
                (customer.orderNumber && customer.orderNumber.includes(this.bnplTable.searchTerm)));
                 
         },
         filteredBNPLCustomer() {
                 return this.bnplTableCustomerView.items.filter(customer =>
                (customer.name && customer.name.toLowerCase().includes(this.bnplTable.searchTerm)) ||
                (customer.email && customer.email.toLowerCase().includes(this.bnplTable.searchTerm)) ||
                (customer.phone && customer.phone.includes(this.bnplTable.searchTerm)) ||
                (customer.orderNumber && customer.orderNumber.includes(this.bnplTable.searchTerm)));
         },
     },
        mounted() {
            this.getBNPLData()
        
        },
        
        methods: {
            customerTrxRowSelected(item)
            {
                window.location.replace('/orders?order-number=' + item.id + '&source=/bnpl?customer-view=1')
            },
            formatDate(date,format) {
                const finaldate = moment(date).format(format);
                return finaldate;
            },
            viewPaymentModal()
            {
                this.bnplTableCustomerView.viewPaymentTransaction = (this.bnplTableCustomerView.viewPaymentTransaction) ? false : true
            },
            receiveBulkAmountModalOpen()
            {
                this.getPaymentGateways()
                this.settleDebt.customerDetails = this.bnplTableCustomerView.customerTrxTable.selectedCustomer
                this.settleDebt.bulkAmount = this.bnplTableCustomerView.customerTrxTable.selectedCustomer.clientBalance
                this.$refs.receiveBulkAmountModal.show()
            },
            getPaymentGateways() {
                axios.get('/api/payments').then(results => {
                    this.settleDebt.paymentGateways = results.data
                    $.each(this.paymentGateways, (index, payment) => {
                        if (!payment.enabled) {
                            this.disabledPaymentGateways++
                        }
                    })
                })
            },
            submitBulkAmount()
            {
                if(this.settleDebt.bulkAmountExceedErr ==='' && this.settleDebt.splitPaymentSelectErr ==='' && this.settleDebt.splitPaymentSelect !==null)
                {
                    axios.post('/api/process-bulk-bnpl-pay',{...this.settleDebt}).then(results=>{
                    if(results.status === 200)
                    {
                        window.location.reload()
                    }
                }).catch()
                }
                else{
                    this.settleDebt.bulkAmountExceedErr = "There was an error"
                
                }
          
            },
            sendReminder(id)
            {
                axios.post('/api/send-bnpl-reminder',{id:id}).then(results=>{
                    if(results.status === 200)
                    {
                        this.$refs.bnplDetailsModal.hide()

                        this.$root.$toasts.push({
                            type:'success',
                            message:'Reminder sent successfully'
                        })
                    }
                })
            },
            deleteBNPL(id)
            {
                axios.delete('/api/delet-bnpl',{params:{id:id}})
                .then(results=>{
                    if(results.status === 200)
                    {
                        this.$refs.bnplDetailsModal.hide()
                        this.$root.$toasts.push({
                            type:'success',
                            message:'BNPL deleted successfully'
                        })
                    }
                    else{
                        this.$refs.bnplDetailsModal.hide()
                        this.$root.$toasts.push({
                            type:'error',
                            message:'There was an error'
                        })
                    }
                })
            },
           async reverseBulkTransaction(data,customer)
            {
                const requestData = {
                    data,customer
                }
                console.log(data.time)
                axios.post('/api/reverse-bnpl-transaction',{requestData}).then(results=>{
                    if(results.status === 200){
                        console.log(results.data)
                    }
                });
            },
            searchCustomers() {
                
                const searchTerm = this.bnplTable.searchTerm.toLowerCase();

                if(this.customerView == 0)
                {
                    this.bnplTable.filteredCustomers = this.bnplTable.items.filter(customer =>
                (customer.name && customer.name.toLowerCase().includes(searchTerm)) ||
                (customer.email && customer.email.toLowerCase().includes(searchTerm)) ||
                (customer.phone && customer.phone.includes(searchTerm)) ||
                (customer.orderNumber && customer.orderNumber.includes(searchTerm)));
                }
                else{
                    this.bnplTable.filteredCustomers = this.bnplTableCustomerView.items.filter(customer =>
                (customer.name && customer.name.toLowerCase().includes(searchTerm)) ||
                (customer.email && customer.email.toLowerCase().includes(searchTerm)) ||
                (customer.phone && customer.phone.includes(searchTerm)) ||
                (customer.orderNumber && customer.orderNumber.includes(searchTerm)));
                }
              
                
        },
            rowSelected(items) {

                this.bnplTable.searchTable=false
                if(this.customerView == 0)
                {
                    this.selectedBNPLCustomer = items
                    this.$refs.bnplDetailsModal.show()

                }
                else
                {

                }
               
            },
            rowSelectedTransaction(items) {
               window.location.replace('/orders?order-number=' + items.orderId + '&source=/bnpl?customer-view=1')
               
            },
            rowCustomerSelected(items) {
    const transactions = items.transactions;
    const paymentTransactionsObject = items.paymentTransactions;


    // Setting selected customer details
    const selectedCustomer = this.bnplTableCustomerView.customerTrxTable.selectedCustomer;
    selectedCustomer.id = items.id;
    selectedCustomer.name = items.name;
    selectedCustomer.phone = items.phone;
    selectedCustomer.totalAmount = items.totalAmount;
    selectedCustomer.totalAmountBalance = items.totalAmountBalance;
    selectedCustomer.clientBalance = items.clientBalance;
    selectedCustomer.paidAmount = items.paidAmount;

    // Processing BNPL transactions
    const bnplTrxArray = transactions
        .filter(value => value.finalorder)
        .map(value => ({
            id: value.id,
            due_date: value.due_date,
            amount: value.amount,
            deposit: value.deposit,
            order: value.finalorder || {},
            status: value.finalorder ? value.finalorder.status : 0,
            order_number: value.finalorder ? value.finalorder.order : '',
            orderId: value.finalorder ? value.finalorder.id : '',
        }));

    // Processing payment transactions
    const paymentTrxArray = []
    //     .filter(value => value.finalorder);
    for (const dateKey in paymentTransactionsObject) {
    if (paymentTransactionsObject.hasOwnProperty(dateKey)) {
        const entry = paymentTransactionsObject[dateKey];
        console.log(`Date: ${dateKey}`);
        if(entry.totalPaidAmount > 0){
            paymentTrxArray.push(entry); 
        }
     // Access the entry object for the current date key
    }
}
    // Updating items in the views
    this.bnplTableCustomerView.customerTrxTable.items = bnplTrxArray;
    this.bnplTableCustomerView.paymentTransactionsTable.items = paymentTrxArray;

    // Showing the customer transactions
    this.$refs.bnplCustomerTransactions.show();
},

            
            getBNPLData() {
                
                axios.get('/api/get-bnpl',{params:{customerView:this.customerView}})
                    .then(result => {
                        if(result.data.customerView)
                        {
                            
                            const bnplCustomerData = result.data;
                            //  this.bnplTableCustomerView.customerTransactions = result.data.customer;
                            const bnplArray = []
                            $.each(bnplCustomerData, function(key, value) {
                                if(value.customer)
                                {
                                    
                                    bnplArray.push({
                                    name: (value.customer.full_name) ? value.customer.full_name : '',
                                    id: (value.customer.id) ? value.customer.id : '',
                                    phone: (value.customer.phone) ? value.customer.phone : '',
                                    email: (value.customer.email) ? value.customer.email : '',
                                    transactions:value.transactions,
                                    paymentTransactions:value.splitOrderPayments,
                                    totalAmount:value.totalAmount.toLocaleString('en-KE', {
                                        style: 'currency',
                                        currency: 'KES'
                                    }),
                                    totalAmountBalance:value.balances.toLocaleString('en-KE', {
                                        style: 'currency',
                                        currency: 'KES'
                                    }),
                                    balance:(value.balances) ? value.balances.toLocaleString('en-KE', {
                                        style: 'currency',
                                        currency: 'KES'
                                    }) : 0,
                                    clientBalance:(value.balances) ? value.balances : 0,
                                    paidAmount:value.paidAmount.toLocaleString('en-KE', {
                                        style: 'currency',
                                        currency: 'KES'
                                    })
                                
                                
                                })
                                }
                                
                        
                            });
                    
                            this.bnplTableCustomerView.items = bnplArray;
                            
                        }
                        else{
                        
                            const bnplData = result.data;
                            const bnplArray = []
                            $.each(bnplData, function(key, value) {
                            
                                if(value.finalorder && value.customer)
                                {

                                        bnplArray.push({
                                        name: (value.customer.full_name),
                                        id: value.id,
                                        phone: value.customer.phone,
                                        email: value.customer.email,
                                        due_date: value.due_date,
                                        amount: value.amount,
                                        deposit: value.deposit,
                                        customer:value.customer,
                                        order:(value.finalorder) ? value.finalorder : {},
                                        status:(value.finalorder) ? value.finalorder.status : 0,
                                        orderNumber:(value.finalorder) ? value.finalorder.order : '',
                                        orderId:(value.finalorder) ? value.finalorder.id : '',
                                    
                                    })
                                }
                               
                        
                            });
                    
                            this.bnplTable.items = bnplArray;
                        }
                        
                    });
            }
        },
        watch:{
            'bnplTable.searchTerm': function(){
                if(this.bnplTable.searchTerm.length > 0)
                {
                    this.bnplTable.searchTable = true
                    this.searchCustomers();
                }
                else{
                    this.bnplTable.searchTable = false
                }
                
            },
        
            'settleDebt.bulkAmount': function(){
                if(this.settleDebt.bulkAmount > this.bnplTableCustomerView.customerTrxTable.selectedCustomer.clientBalance)
                {
                    this.settleDebt.bulkAmountExceedErr = "You can only receive amount not exceeding customer's debt"
                }  
                else{

                    this.settleDebt.splitPaymentSelectErr = ''
                    this.settleDebt.bulkAmountExceedErr = ''
                }
            },
            'settleDebt.splitPaymentSelect': function(){
               
                if(this.settleDebt.splitPaymentSelect === 'null' )
                {
                    this.settleDebt.splitPaymentSelectErr = "You need to select atleast one mode of payment"
                } 
                else if(this.settleDebt.splitPaymentSelect.payment_method.toLowerCase() === 'buy now pay later'  )
                {
                    this.settleDebt.splitPaymentSelectErr = "Payment can't be BNPL"
                } 
                else{ 
                    this.settleDebt.splitPaymentSelectErr = ''
                    this.settleDebt.bulkAmountExceedErr = ''
                }  
            }
            
        }
    }
</script>